require("gsap/CSSPlugin");

window.$ = window.jQuery = require("jquery");
require("datatables.net");
require("datatables.net-responsive");
// require("datatables.net-fixedheader");

//images
require("../../../images/icons/icon-fb.svg");
require("../../../images/icons/icon-instagram.svg");

var Navigo = require("navigo");
var Handlebars = require("handlebars/runtime");
var results_table_template = require("../templates/results-table.handlebars");
var racer_details_template = require("../templates/racer-details.handlebars");



var initShareButtons = require("../blocks/share");

var page_scroll_position;

var buildDiplomaHtml = function (data, pageUrl) {
	var rd = data.racer_data || {};
	var rr = data.racer_result || {};
	var rc = data.race_data || {};
	var st = data.stats || {};
	var routeName = data.route_name || "";

	var raceDate = "";
	if (rc.race_date) {
		var d = new Date(rc.race_date);
		var months = ["gennaio","febbraio","marzo","aprile","maggio","giugno",
		              "luglio","agosto","settembre","ottobre","novembre","dicembre"];
		raceDate = d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
	}

	var raceLocation = "";
	if (rc.race_gmaps_city) {
		raceLocation = rc.race_gmaps_city;
		if (rc.race_gmaps_state) { raceLocation += " (" + rc.race_gmaps_state + ")"; }
	}

	var athleteName = ((rd.name || "") + " " + (rd.surname || "")).trim();
	var logoUrl = window.location.origin + "/images/logo-typography-black.svg";
	var organizerLogoUrl = (typeof ORGANIZER_LOGO_URL !== "undefined" && ORGANIZER_LOGO_URL) ? ORGANIZER_LOGO_URL : "";
	var qrUrl = "https://api.qrserver.com/v1/create-qr-code/?size=128x128&data=" + encodeURIComponent(pageUrl || window.location.href);

	// Medaglia SVG: nastro (arancio+giallo) + cerchio oro + stella
	var medalSvg =
		"<svg width=\"40\" height=\"50\" viewBox=\"0 0 40 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">" +
			"<rect x=\"10\" y=\"0\" width=\"8\" height=\"15\" rx=\"2\" fill=\"#EA7125\"/>" +
			"<rect x=\"22\" y=\"0\" width=\"8\" height=\"15\" rx=\"2\" fill=\"#FFB60F\"/>" +
			"<circle cx=\"20\" cy=\"34\" r=\"16\" fill=\"#FFB60F\"/>" +
			"<circle cx=\"20\" cy=\"34\" r=\"12\" fill=\"#FFC72C\"/>" +
			"<polygon points=\"20,25 22,31 29,31 23,35 25,41 20,38 15,41 17,35 11,31 18,31\" fill=\"#212121\" opacity=\"0.2\"/>" +
		"</svg>";

	var css = [
		"@page { size: A5 landscape; margin: 0; }",
		"* { box-sizing: border-box; margin: 0; padding: 0; }",
		"html, body { width: 794px; height: 560px; overflow: hidden; }",
		"body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-weight: 300; color: #212121; background: #fff; }",
		".diploma-page { width: 794px; height: 560px; overflow: hidden; display: flex; flex-direction: column; border-left: 6px solid #FFB60F; page-break-inside: avoid; page-break-after: avoid; }",
		".diploma-header { display: flex; align-items: center; gap: 12px; padding: 16px 20px 14px 20px; border-bottom: 3px solid #FFB60F; }",
		".diploma-title { font-size: 30px; font-weight: 300; letter-spacing: 0.25em; text-transform: uppercase; color: #212121; line-height: 1; }",
		".diploma-logo { height: 34px; }",
		".diploma-organizer-logo { height: 34px; margin-left: auto; margin-right: 16px; }",
		".diploma-body { display: flex; padding: 14px 20px 10px 20px; gap: 20px; flex: 1; min-height: 0; overflow: hidden; }",
		".diploma-left { flex: 1; padding-right: 18px; border-right: 1px solid #E5E5E5; display: flex; flex-direction: column; }",
		".diploma-right { flex: 0 0 155px; display: flex; flex-direction: column; gap: 6px; justify-content: center; }",
		".event-meta { margin-bottom: 10px; }",
		".event-date { font-size: 10px; color: #44687D; text-transform: uppercase; letter-spacing: 0.1em; font-weight: 600; }",
		".event-location { font-size: 10px; color: #888; margin-top: 1px; }",
		".event-title { margin-top: 8px; font-size: 13px; font-weight: 700; color: #212121; line-height: 1.2; }",
		".event-route { margin-top: 2px; font-size: 10px; color: #44687D; }",
		".athlete-divider { border: none; border-top: 1px solid #E5E5E5; margin: 8px 0; }",
		".athlete-name { font-size: 21px; font-weight: 700; color: #212121; line-height: 1.15; margin-bottom: 8px; }",
		".athlete-meta { list-style: none; }",
		".athlete-meta li { font-size: 10px; color: #555; margin-bottom: 3px; display: flex; gap: 6px; }",
		".athlete-meta li label { font-weight: 600; color: #212121; min-width: 66px; }",
		".athlete-qr { margin-top: auto; padding-top: 8px; display: flex; align-items: center; gap: 8px; }",
		".athlete-qr img { display: block; width: 60px; height: 60px; flex-shrink: 0; }",
		".athlete-qr-label { font-size: 8px; color: #bbb; line-height: 1.4; max-width: 90px; }",
		".stat-box { border-radius: 4px; padding: 0 12px; height: 44px; color: #fff; display: flex; flex-direction: column; justify-content: center; }",
		".stat-box .stat-label { font-size: 8px; text-transform: uppercase; letter-spacing: 0.12em; font-weight: 600; opacity: 0.85; margin-bottom: 2px; }",
		".stat-box .stat-value { font-size: 20px; font-weight: 700; line-height: 1; }",
		".stat-bib { background-color: #FFB60F; color: #212121; }",
		".stat-overall { background-color: #212121; }",
		".stat-category { background-color: #44687D; }",
		".stat-time { background-color: #EA7125; }",
		".diploma-footer { border-top: 2px solid #FFB60F; padding: 8px 20px; display: flex; align-items: center; justify-content: space-between; gap: 10px; }",
		".footer-tagline { font-size: 9px; color: #aaa; letter-spacing: 0.08em; }",
		".footer-link { font-size: 10px; color: #44687D; text-decoration: none; letter-spacing: 0.05em; }",
		".footer-logo { height: 22px; }",
		"@media print {",
		"  html, body { width: 794px; height: 560px; }",
		"  .diploma-page { -webkit-print-color-adjust: exact; print-color-adjust: exact; }",
		"  .stat-bib, .stat-overall, .stat-category, .stat-time { -webkit-print-color-adjust: exact; print-color-adjust: exact; }",
		"}"
	].join("\n");

	var teamRow    = rr.team     ? "<li><label>Team</label><span>" + rr.team + "</span></li>" : "";
	var catRow     = rr.category ? "<li><label>Categoria</label><span>" + rr.category + "</span></li>" : "";
	var genderRow  = rd.gender   ? "<li><label>Sesso</label><span>" + rd.gender + "</span></li>" : "";
	var bibVal     = rr.bib      ? "#" + rr.bib : "—";
	var overallVal = st.overall_position  ? "#" + st.overall_position  : "—";
	var catVal     = st.category_position ? "#" + st.category_position : "—";
	var timeVal    = st.total_time || "—";

	return "<!DOCTYPE html>\n" +
		"<html lang=\"it\"><head><meta charset=\"UTF-8\">" +
		"<meta name=\"viewport\" content=\"width=794, initial-scale=1.0\">" +
		"<title>Diploma - " + athleteName + "</title>" +
		"<style>" + css + "</style></head><body>" +
		"<div class=\"diploma-page\">" +
		"<div class=\"diploma-header\">" +
			medalSvg +
			"<div class=\"diploma-title\">Diploma</div>" +
			(organizerLogoUrl ? "<img class=\"diploma-organizer-logo\" src=\"" + organizerLogoUrl + "\" alt=\"organizzatore\" />" : "") +
			"<img class=\"diploma-logo\" src=\"" + logoUrl + "\" alt=\"IDchronos\"" + (organizerLogoUrl ? "" : " style=\"margin-left:auto\"") + " />" +
		"</div>" +
		"<div class=\"diploma-body\">" +
			"<div class=\"diploma-left\">" +
				"<div class=\"event-meta\">" +
					"<div class=\"event-date\">" + raceDate + "</div>" +
					"<div class=\"event-location\">" + raceLocation + "</div>" +
					"<div class=\"event-title\">" + (rc.race_title || "") + "</div>" +
					"<div class=\"event-route\">" + routeName + "</div>" +
				"</div>" +
				"<hr class=\"athlete-divider\" />" +
				"<div class=\"athlete-name\">" + athleteName + "</div>" +
				"<ul class=\"athlete-meta\">" + teamRow + catRow + genderRow + "</ul>" +
				"<div class=\"athlete-qr\">" +
					"<img src=\"" + qrUrl + "\" alt=\"QR risultati\" />" +
					"<span class=\"athlete-qr-label\">Scansiona per rivivere il tuo risultato</span>" +
				"</div>" +
			"</div>" +
			"<div class=\"diploma-right\">" +
				"<div class=\"stat-box stat-bib\"><div class=\"stat-label\">Pettorale</div><div class=\"stat-value\">" + bibVal + "</div></div>" +
				"<div class=\"stat-box stat-overall\"><div class=\"stat-label\">Posizione assoluta</div><div class=\"stat-value\">" + overallVal + "</div></div>" +
				"<div class=\"stat-box stat-category\"><div class=\"stat-label\">Posizione categoria</div><div class=\"stat-value\">" + catVal + "</div></div>" +
				"<div class=\"stat-box stat-time\"><div class=\"stat-label\">Tempo ufficiale</div><div class=\"stat-value\">" + timeVal + "</div></div>" +
			"</div>" +
		"</div>" +
		"<div class=\"diploma-footer\">" +
			"<a class=\"footer-link\" href=\"https://www.idchronos.it\" target=\"_blank\">www.idchronos.it</a>" +
			"<div style=\"display:flex;align-items:center;gap:10px;\">" +
				"<div class=\"footer-tagline\">cronometrato da</div>" +
				"<img class=\"footer-logo\" src=\"" + logoUrl + "\" alt=\"IDchronos\" />" +
			"</div>" +
		"</div>" +
		"</div>" +
		"<script>window.onload=function(){window.print();window.onafterprint=function(){window.close();};};<\/script>" +
		"</body></html>";
};

if (typeof CUR_RACE_ID !== "undefined") {
	var share_url =
		APP_ROOT +
		"/" +
		LOCALE +
		"/" +
		TRANSLATED_SECTION_NAME +
		"/" +
		CUR_RACE_ID +
		"/" +
		CUR_RACE_SLUG;

	var routeSelect; // Custom select instance for route dropdown
	var results_loading_status = "idle";

	/*
	 * Racer details
	 */
	var loadRacerDetails = function (race_id, racer_id) {
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/racer/" +
				racer_id,
			displayRacerDetails,
			"json"
		);
	};

	var displayRacerDetails = function (racer_details) {
		racer_details.app_root = APP_ROOT;

		$(document).ready(function () {
			page_scroll_position = $(document).scrollTop();
			$(document).scrollTop(0);

			var racer_details_html = racer_details_template(racer_details);

			$(".page-content").css({ display: "none" });

			$(".content-wrapper").append(racer_details_html);

			var currentUrl = window.location.href;
			$(".racer-details .share-fb-button").data("link", currentUrl);
			$(".racer-details .share-instagram-button").data("link", currentUrl);

			initShareButtons($(".share-race-results"));

			$(".racer-details #print-btn").on("click", function () {
				var w = window.open("", "_blank", "width=794,height=560");
				if (!w || w.closed || typeof w.closed === "undefined") {
					alert("Il tuo browser ha bloccato la finestra del diploma. Consenti i popup per questo sito.");
					return;
				}
				w.document.write(buildDiplomaHtml(racer_details, currentUrl));
				w.document.close();
			});

			$(".back-button").click(function (e) {
				e.preventDefault();
				router.navigate(router.root, true);
			});
		});
	};

	var getRouteResults = function (race_id, route_id) {
		results_loading_status = "loading_route_data";
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/route/" +
				route_id,
			displayRoutesResults,
			"json"
		);
	};

	var displayRoutesResults = function (race_data) {
		/*
		 * Compile results template
		 */
		race_data.APP_ROOT = APP_ROOT;

		var html = results_table_template(race_data);

		$(".race-results-content").empty();

		$(html).appendTo(".race-results-content");

		// Solo le righe del corpo tabella aprono il dettaglio atleta: legare
		// il click a "#standard-table tr" includeva anche la riga di header
		// (senza data-racer_id), per cui ordinare una colonna apriva il
		// dettaglio "racer/undefined" vuoto. Delega su tbody: regge i redraw
		// di DataTables (ordinamento, paginazione, filtri).
		$("#standard-table").on("click", "tbody tr", function (e) {
			var racerId = $(this).data("racer_id");
			if (racerId) {
				router.navigate("racer/" + racerId);
			}
		});

		// Etichette localizzate (arrivano da race_data.translations, con fallback)
		var t = race_data.translations || {};

		var dataTable = $("#standard-table").DataTable({
			bAutoWidth: false,
			order: [[0, "asc"]],
			responsive: {
				details: false,
			},
			paging: !$("#standard-table").hasClass("no-pagination"),
			fixedHeader: false,
			language: {
				paginate: {
					previous: t.previous || "Previous",
					next: t.next || "Next",
				},
			},
			infoCallback: function (settings, start, end, max, total, pre) {
				return start + "-" + end + " " + (t.of || "of") + " " + max;
			},
			dom: 't<"table-footer"ip<"dataTables_length">><"clear">',
			drawCallback: function (settings) {
				if (
					$("#standard-table").DataTable().page.info()
						.recordsDisplay == 0
				) {
					$(".table-footer").hide();
				} else {
					$(".table-footer").show();
				}

				if (settings.oPreviousSearch.sSearch.length == 0) {
					// if length == 0 user il filtering but not searching

					// update rows index after filtering
					$("#standard-table")
						.DataTable()
						.column(0, { search: "applied", order: "original" })
						.nodes()
						.each(function (cell, i) {
							cell.innerHTML = i + 1;
						});
				}
			},

			initComplete: function () {
				// console.log($("#standard-table").hasClass("no-pagination"));
				// if ($("#standard-table").hasClass("no-pagination")) {
				// 	$(".table-footer").hide();
				// }
			},
		});

		/*
		 * Search
		 */
		$("#results-search__input").keyup(function () {
			dataTable.search($(this).val()).draw();
		});

		/*
		 * DesktopFilters
		 */
		var $genderFilter = $("#gender-select");
		var $categoryFilter = $("#category-select");

		$genderFilter.on("change", function () {
			dataTable.column(5).search($(this).val()).draw();
		});

		$categoryFilter.on("change", function () {
			dataTable.column(6).search($(this).val()).draw();
		});

		/*
		 * Mobile Filters
		 */

		// gender
		$(".gender-mobile-filter li.filter-value").each(function () {
			$(this).on("click", function (e) {
				e.stopPropagation();

				if ($(this).hasClass("active-filter")) {
					// reset filter
					$(this).removeClass("active-filter");
					setTableFilter(5, "");
				} else {
					$(this).parent().find("li").removeClass("active-filter");
					$(this).addClass("active-filter");

					setTableFilter(5, $(this).data("value"));
				}
			});
		});

		// category
		$(".category-mobile-filter li.filter-value").each(function () {
			$(this).on("click", function (e) {
				e.stopPropagation();

				if ($(this).hasClass("active-filter")) {
					// reset filter
					$(this).removeClass("active-filter");
					setTableFilter(6, "");
				} else {
					$(this).parent().find("li").removeClass("active-filter");
					$(this).addClass("active-filter");

					setTableFilter(6, $(this).data("value"));
				}
			});
		});

		var setTableFilter = function (column_num, value) {
			dataTable.column(column_num).search(value).draw();
		};

		// open filters
		$(".mobile-filters-button").on("click", function () {
			$(".mobile-filters-overlay").addClass("open");
		});

		// apply and close filters
		$(".apply-filters, .mobile-filters-overlay").on("click", function () {
			$(".mobile-filters-overlay").removeClass("open");

			if ($(".mobile-filters-content").find("li.active-filter").length) {
				$(".mobile-filters-button").addClass("filters-enabled");
			} else {
				$(".mobile-filters-button").removeClass("filters-enabled");
			}
		});

		// reset
		$(".reset-filters").on("click", function () {
			setTableFilter(5, "");
			setTableFilter(6, "");
			$(".active-filter").removeClass("active-filter");
		});

		/*
		 *	Results per page menu
		 */
		var $page_length_select = $(
			'<select id="length-select" class="sld-select--no-border"></select>'
		);
		$page_length_select.append('<option value="10">10</option>');
		$page_length_select.append('<option value="25">25</option>');
		$page_length_select.append('<option value="50">50</option>');
		$page_length_select.appendTo(".dataTables_length");
		$(".dataTables_length").append(
			'<div class="select-label">' + (t.rows_per_page || "rows per page") + "</div>"
		);

		$page_length_select.on("change", function () {
			dataTable.page.len($(this).val()).draw();
		});

		/*
		 * append pagination commands outside table box
		 */
		$(".table-footer").appendTo(".page-content.page-content--grey");

		results_loading_status = "idle";
	};

	$(document).ready(function () {
		initShareButtons($(".share-race-results"));

		/*
		 * Route selection handling
		 */
		var $routeSelectElement = $("#route-select");
		var enabledOptionsCount = $routeSelectElement.find("option:not([disabled])").length;

		// Attach change listener for loading results when route is selected
		$routeSelectElement.on("change", function () {
			var selectedRouteId = $(this).val();

			if (selectedRouteId && selectedRouteId !== "" && results_loading_status == "idle") {
				results_loading_status = "loading_route_data";
				// Hide the "select a route" splash message
				$('.select-route-splash').hide();
				getRouteResults(CUR_RACE_ID, selectedRouteId);
			}
		});

		if (enabledOptionsCount === 1) {
			// Single route available - auto-select it and load results
			var singleRouteId = $routeSelectElement.find("option:not([disabled])").val();
			if (singleRouteId) {
				// Select the single route in the dropdown
				$routeSelectElement.val(singleRouteId);
				// Auto-load results for this route
				getRouteResults(CUR_RACE_ID, singleRouteId);
			}
		} else if (enabledOptionsCount > 1) {
			// Multiple routes available - show dropdown with selection message
			var v_centred_splat_margin_top =
				($(window).height() -
					$(".main-nav").outerHeight() -
					$(".page-header").outerHeight()) /
					2 -
				$(".select-route-splash").height() / 2;

			if (v_centred_splat_margin_top > 0)
				$(".select-route-splash").css({
					"margin-top": v_centred_splat_margin_top,
				});

			$(".select-route-splash").animate({ opacity: 1 }, 300);
		}
	});

	/*
	 * Results router
	 */
	var router = new Navigo(
		(root =
			APP_ROOT +
			"/" +
			LOCALE +
			"/" +
			TRANSLATED_SECTION_NAME +
			"/" +
			CUR_RACE_ID +
			"/" +
			CUR_RACE_SLUG),
		(useHash = false)
	);

	router
		.on({
			"/racer/:id_racer": function (params) {
				loadRacerDetails(CUR_RACE_ID, params.id_racer);
			},

			"/": function () {
				$(".racer-details").remove();
				$(".page-content").css({ display: "block" });

				setTimeout(function () {
					$(document).scrollTop(page_scroll_position);
				}, 50);
			},
		})
		.resolve();
}
